import { BASE_URL } from '../Config';
import { User } from '../containers/AuthProvider';
import { StatusModel } from '../pages/Sandbox.page';
import { Stack } from '../models/Stack';
import { PullRequest } from '../models/PullRequest';

const toJSON = response => {
  try {
    if (response.status === 204) {
      return;
    }
    return response.json();
  } catch (e) {
    console.error(e);
    return {};
  }
};

const doRequest = async <T>(endpoint: string, method = 'GET', body?: object): Promise<T> => {
  const headers: HeadersInit = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  };

  const request: RequestInit = {
    method,
    credentials: 'include',
    headers
  };

  if (body) {
    request.body = JSON.stringify(body);
  }

  const url = BASE_URL + endpoint;
  return new Promise((resolve, reject) => {
    fetch(url, request)
      .then(toJSON)
      .then(resolve)
      .catch(err => reject(err));
  });
}


export const getPullRequest = (): Promise<PullRequest[]> =>
  doRequest<PullRequest[]>('/v1/pull-requests');

export const getStacks = (): Promise<Stack[]> =>
  doRequest<Stack[]>('/v1/stacks');

export const doLogin = (email: string, password: string): Promise<User> =>
  doRequest<User>('/v1/login', 'POST', { email, password });

export const planSandbox = async (branchName: string, actor: string, repo: string, pullRequestNumber: string, idModifier: number) =>
  doRequest('/v1/new-sandbox', 'POST', {
    branchName,
    actor,
    repo,
    pullRequestNumber,
    idModifier
  });

export const removeSandbox = async (uniqueId: string, branchName: string, actor: string) =>
  doRequest('/v1/remove-sandbox', 'DELETE', {
    uniqueId,
    branchName,
    actor
  });

export const destroyStack = async (stackId: string, actor: string) =>
  doRequest('/v1/destroy-stack', 'DELETE', {
    stackId,
    actor
  });

export const getStatus = async (): Promise<StatusModel> =>
  doRequest('/v1/status')

export const getPullRequestWithStacksMerge = async (): Promise<PullRequest[]> => {
  const pullRequests = await getPullRequest();

  const pullRequestsWithStacks = pullRequests.map(pullRequest => ({
    ...pullRequest,
    zzmExistingSandbox: Boolean(pullRequest.zzmExistingSandboxes?.length)
  }));

  const pullRequestsWithExistingSandbox = pullRequestsWithStacks.filter(pullRequest => pullRequest.zzmExistingSandbox);

  return pullRequestsWithStacks.map(pullRequest => {
    if (pullRequest.zzmExistingSandbox) {
      return pullRequest;
    }
    return {
      ...pullRequest,
      zzmExistingSandbox: Boolean(pullRequestsWithExistingSandbox.find(pullRequestWithSandbox => pullRequestWithSandbox.branchName === pullRequest.branchName))
    };
  });
};
